<template>
  <div class="d-flex flex-column flex-grow-1">
    <TabHeader :header="$t('js.sidebar.headers.amendments')" />
    <div class="flex-grow-1 p-3 overflow-auto bg-blur-dark pretty-scroll-theme"
         id="chat"
         @scroll="checkScroll"
         style="overflow-y: auto; height: 0;">
      <div v-if="amendments.length < 1" class="text-white-50 font-italic text-center">
        {{ $t('js.sidebar.amendments.no_amendments') }}
      </div>
      <Amendment v-for="item in amendments" :item="item" :key="`amendment_${item.id}`" />
    </div>
  </div>
</template>

<script>
  import {mapState, mapActions, mapGetters, mapMutations} from 'vuex'
  import TabHeader from "./TabHeader"
  import HighlightModal from "../HighlightModal"
  import Amendment from "../../shared/posts/Amendment"

  export default {
    name: 'Amendments',
    components: {Amendment, HighlightModal, TabHeader},
    data(){
      return {
        scrolled: false,
      }
    },
    computed: {
      ...mapState(['election', 'voting', 'posts', 'slides', 'postsUrl', 'chatUser']),
      ...mapGetters(['activeSlide', 'firstAvailableLocale']),
      amendments(){
        return this.posts.filter(p => p.type === 'Amendment')
      },
      ballotSlides(){
        return this.slides.filter(s => s.type === 'Slides::BallotSlide')
      }
    },
    watch: {
      posts: function(posts){
        if(!this.scrolled){
          this.$nextTick(function () {
            let d = $('#chat');
            d.scrollTop(d.prop("scrollHeight"));
          })
        }
      },
    },
    methods: {
      ...mapMutations(['markAllPostsRead']),
      ...mapActions(['updateStatus']),
      checkScroll(){
        let d = $('#chat');
        this.scrolled = (d.scrollTop() ) < (d.prop("scrollHeight") - d.prop("offsetHeight"))
      }
    },
    mounted(){
      this.$nextTick(function () {
        let d = $('#chat');
        d.scrollTop(d.prop("scrollHeight"));
      })
    }
  }
</script>
